import React, { useState } from "react";
import useStyles from "../Styles";
import {
  IconButton,
  Grid,
  Box,
  Tabs,
  Tab,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useSelector } from "react-redux";

// Import Sidebars
import CentralAZChartTab from "../CentralAZWaterUse/CentralAZChartTab";
import CentralAZAboutTab from "../CentralAZWaterUse/CentralAZAboutTab";
import GaugePieChartTab from "../GaugePieChart/GaugePieChartTab";
import GaugePieAboutTab from "../GaugePieChart/GaugePieAboutTab";
import AreaChartAboutTab from "../AreaChart/AreaChartAboutTab";
import AreaChartChartTab from "../AreaChart/AreaChartChartTab";
import useIsDevUrl from "hooks/useIsDevUrl";

import ColoradoRiverAccessChartTab from "../ColoradoRiverAccess/ColoradoRiverAccessChartTab";
import ColoradoRiverAccessAboutTab from "../ColoradoRiverAccess/ColoradoRiverAccessAboutTab";

import PolygonMapChartTab from "../PolygonMap/PolygonMapChartTab";
import PolygonMapAboutTab from "../PolygonMap/PolygonMapAboutTab";

const AboutSidebar = (props) => {
  const classes = useStyles();
  const { onClose } = props;
  const [tab, setTab] = useState("charts");
  const { chart } = useSelector((state) => state.technical_view);
  const isDevUrl = useIsDevUrl();

  const onChangeTab = (event, value) => {
    if (!isDevUrl) {
      setTab(value);
    }
  };
  
  return (
    <>
      <Box pl={4} pr={4} pt={1}>
        <IconButton className={classes.closeBtn} onClick={isDevUrl ? () => {} : onClose}>
          <CloseIcon />
        </IconButton>
        <Grid item xs={12} className={classes.tabs}>
          {
            // chart !== "central_arizona_shortage_impacts" &&
            <Tabs
              value={tab}
              onChange={onChangeTab}
              classes={{
                root: classes.tabRoot,
                indicator: classes.tabIndicator,
              }}
            >
              <Tab
                classes={{
                  root: classes.tabInactive,
                  selected: classes.tabActive,
                }}
                value="charts"
                label="Charts"
                className={classes.startingTab}
              ></Tab>
              <Tab
                classes={{
                  root: classes.tabInactive,
                  selected: classes.tabActive,
                }}
                value="about"
                label="About"
                className={classes.endingTab}
              ></Tab>
            </Tabs>
          }
        </Grid>
      </Box>
      <Box>
        {tab === "about" ? (
          <Grid item xs={12} className={classes.aboutBox}>
            {
              {
                colorado_river_access: <ColoradoRiverAccessAboutTab />,
                access_per_capita: <PolygonMapAboutTab />,
                central_az_water_use: <CentralAZAboutTab />,
                colorado_river_water_access: <AreaChartAboutTab/>,
                water_use_versus_access: <GaugePieAboutTab />,
              }[chart]
            }
          </Grid>
        ) : (
          <Grid item xs={12} className={classes.aboutBox}>
            {
              {
                colorado_river_access: <ColoradoRiverAccessChartTab />,
                access_per_capita: <PolygonMapChartTab />,
                central_az_water_use: <CentralAZChartTab />,
                colorado_river_water_access: <AreaChartChartTab/>,
                water_use_versus_access: <GaugePieChartTab />,
              }[chart]
            }
          </Grid>
        )}
      </Box>
    </>
  );
};

export default AboutSidebar;
